import { DemandTopicStatus } from '@synergy/models';

const translationObject: { [Key in DemandTopicStatus]: string } = {
    [DemandTopicStatus.Assigned]: 'app.demandTopicStatus.assigned',
    [DemandTopicStatus.Unassigned]: 'app.demandTopicStatus.unassigned',
    [DemandTopicStatus.NotInterested]: 'app.demandTopicStatus.notInterested',
};

const tooltipTranslationObject: { [Key in DemandTopicStatus]: string } = {
    [DemandTopicStatus.Assigned]: 'app.demandTopicStatus.tooltip.assigned',
    [DemandTopicStatus.Unassigned]: 'app.demandTopicStatus.tooltip.unassigned',
    [DemandTopicStatus.NotInterested]: 'app.demandTopicStatus.tooltip.notInterested',
};

export const getDemandTopicStatusTranslationId = (status: DemandTopicStatus): string => translationObject[status];

export const getDemandTopicStatusTooltipTranslationId = (status: DemandTopicStatus): string =>
    tooltipTranslationObject[status];
